import React, { useState } from 'react';
import { Button, makeStyles, Tooltip } from '@material-ui/core';
import { ScriptFollowUpV2 } from 'typings';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import ExpandLessIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded';
import TimelineRoundedIcon from '@material-ui/icons/TimelineRounded';
import ScriptStepFollowUp from './ScriptStepFollowUp';

interface ScriptStepFollowUpsProps {
  isCurrentStep: boolean;
  scriptFollowUps: ScriptFollowUpV2[];
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(-1),
  },
  button: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),

    '& .MuiButton-endIcon': {
      marginLeft: '4px',
    },
  },
  list: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    position: 'relative',
    textAlign: 'left',
  },
}));

const ScriptStepFollowUps = ({ isCurrentStep, scriptFollowUps }: ScriptStepFollowUpsProps) => {
  const styles = useStyles();

  const currentFollowUpId = useSelector(
    (state: RootState) => state.script.entityV2?.currentFollowUpId
  );

  const [isExpanded, setIsExpanded] = useState(false);

  if (!scriptFollowUps.length) {
    return null;
  }

  let currentFollowUpIndex: number | null = null;
  let buttonText = `${scriptFollowUps.length}`;

  if (isCurrentStep) {
    currentFollowUpIndex = scriptFollowUps.findIndex(
      (followUp) => followUp.id === currentFollowUpId
    );
    buttonText = `${currentFollowUpIndex + 1} / ${scriptFollowUps.length}`;
  }

  return (
    <div className={styles.container}>
      <Tooltip title="Automated Follow-Ups" placement="right" enterDelay={600} arrow>
        <Button
          className={styles.button}
          color="primary"
          onClick={() => setIsExpanded(!isExpanded)}
          startIcon={<TimelineRoundedIcon />}
          endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          size="small"
        >
          {buttonText}
        </Button>
      </Tooltip>
      {isExpanded && (
        <div className={styles.list}>
          {scriptFollowUps.map((followUp, index) => (
            <ScriptStepFollowUp
              key={followUp.id}
              isComplete={currentFollowUpIndex !== null && index <= currentFollowUpIndex}
              isFuture={currentFollowUpIndex === null || index > currentFollowUpIndex + 1}
              isLast={index === scriptFollowUps.length - 1}
              scriptFollowUp={followUp}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ScriptStepFollowUps;
